import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import apiUrl from '../../services/api';

// Thunk to fetch IP data
export const fetchIPData = createAsyncThunk(
    'ipData/fetchIPData',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(apiUrl.fetchIpData);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Slice
const ipDataSlice = createSlice({
    name: 'ipData',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchIPData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchIPData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchIPData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch IP data';
            });
    },
});

export default ipDataSlice.reducer;
